import React, { FC, useState } from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { LocationIcon } from '~/img';
import Drawer, { DRAWER_WIDTH } from '~/components/Drawer';
import GoogleMap, { isValidCoords } from '~/components/GoogleMap';
import MapMarker from '~/components/GoogleMap/MapMarker';
import { Button } from '~/components';

interface Props {
  id: string;
  value?: { latitude: number; longitude: number };
}

const ViewLocation: FC<Props> = (props) => {
  const { value, id } = props;
  const { t } = useTranslation('ksaApplication');

  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  return (
    <>
      <Button
        id={id}
        success={isValidCoords(value)}
        type="default"
        icon={<LocationIcon />}
        onClick={handleOpen}
      >
        {t('View location')}
      </Button>

      <StyledDrawer className="ViewLocation-StyledDrawer" visible={open} onClose={handleClose}>
        <Typography.Title level={4}>{t('Location').toUpperCase()}</Typography.Title>
        <div className="ViewLocation-MapContainer">
          <GoogleMapField
            value={value}
          />
        </div>
      </StyledDrawer>
    </>
  );
};

const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    position: relative;

    .ViewLocation-MapContainer {
      height: calc(100vh - 126px);
      margin: 0 -32px -40px -32px;
    }

    .ViewLocation-SaveButton {
      position: absolute;
      bottom: 40px;
      width: 368px;
      @media (max-width: ${DRAWER_WIDTH}px) {
        width: calc(100vw - 64px);
      }
    }
  }
`;

const GoogleMapField: FC<Omit<Props, 'disabled' | 'id'>> = (props) => {
  const { value } = props;

  const geolocation = {
    lat: value?.latitude || 0,
    lng: value?.longitude || 0,
  };

  console.log(`Google's geolocation: `, geolocation);

  return (
    <GoogleMap
      center={geolocation}
      zoom={isValidCoords(geolocation) ? 16 : undefined}
      options={{ fullscreenControl: false, zoomControl: false }}
    >
      {isValidCoords(geolocation) ? (
        <MapMarker lat={geolocation.lat} lng={geolocation.lng} />
      ) : null}
    </GoogleMap>
  );
};

export default ViewLocation;
